import Menu from "./Menu"
import Discover from "./Discover"
import Footer from "./Footer"
import { useState } from "react"




// const urls = [
//   "home.svg",
//   "followers.svg",
//   "IntiNature.jpeg",
//   "zdenekkounovsky.jpeg",
//   "quim_the_aaron.jpeg",
//   "mafishguy.jpeg",
//   "waterandlight.jpeg",
//   "fanshenrylau.jpeg",
//   "fathomlesslife.jpeg",
//   "daynahardgrove.jpeg",
//   "aquatech_imaging.jpeg"
// ]

const Sidebar = props => {
  const { isMobile } = props

  let [isCollapsed, setIsCollapsed] = useState(true)

  const collapse = () => {
    setIsCollapsed(!isCollapsed)
  }
  
  return ( 
  <nav id="Sidebar" className="col-2 navbar navbar-expand-lg navbar-light">
    <button 
    className="navbar-toggler d-block d-lg-none" 
    type="button" 
    onClick={collapse}
    >
      <span className="navbar-toggler-icon"></span>
    </button>
    <div 
    className={`${isCollapsed ? "collapse" : ""} navbar-collapse`} 
    id="navbarNavAltMarkup"
    >
    <Menu isMobile={isMobile} />
    <hr className="d-none d-lg-block" />
    <Discover />
    <hr className="d-none d-lg-block" />
    <Footer />
    {/*<div id="Menu" className="row col-2">
          {urls.map((url, i) => {
            return (
              <Link to={url.route}>
                <ProfilePic
                  key={i}
                  className={url.type}
                  name={url.type}
                  url={url.link}
                  alt={url.type}
                />
              </Link>
            )
          })}
          <Discover />
          <Footer />
        </div>*/}
</div>
</nav>
)
}

export default Sidebar